<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="toolManufacturer"
      [label]="'case.fields.toolManufacturer.label' | translate"
      [helpText]="'case.fields.toolManufacturer.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('toolManufacturer')?.value || ''
      }"
      [entry]="entry1"
      (onSelectEvent)="onSelectToolFields($event, dropdownTypeEnum.TOOL)"
      (onClearEvent)="resetToolFields(dropdownTypeEnum.TOOL, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="tool"
      [label]="'case.fields.tool.label' | translate"
      [helpText]="'case.fields.tool.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="toolItems"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('toolManufacturer')?.value || '',
        entry2: form.get('tool')?.value || '',
      }"
      [entry]="entry2"
      (onSelectEvent)="onSelectToolFields($event, dropdownTypeEnum.CHAMBER)"
      (onClearEvent)="resetToolFields(dropdownTypeEnum.CHAMBER, null)"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="chamber"
      [label]="'case.fields.chamber.label' | translate"
      [helpText]="'case.fields.chamber.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="chamberItems"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownType,
        entry1: form.get('toolManufacturer')?.value || '',
        entry2: form.get('tool')?.value || '',
        entry3: form.get('chamber')?.value || '',
      }"
      [entry]="entry3"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="processType"
      [label]="'case.fields.processType.label' | translate"
      [helpText]="'case.fields.processType.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownProcessType,
        entry1: form.get('processType')?.value || ''
      }"
      [entry]="'entry1'"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-textarea-form-field
      formControlName="additionalProcessInfo"
      [label]="'case.fields.additionalProcessInfo.label' | translate"
      [helpText]="'case.fields.additionalProcessInfo.help'"
      [viewMode]="viewMode"
      [textareaRows]="5"
    ></app-textarea-form-field>
  </div>
</div>
